import gql from "graphql-tag";

export const ProductFieldsFragment = gql`
  fragment ProductFields on Product {
    _id
    name
    logo
    slug
    description
    about
    link
    contactPage
    isDisruptor
    videos
    screenshots {
      url
      alt
    }
    languagesOffered
    viewerDidBookmark
    allowRequestTranslation
    tags {
      _id
      name
      slug
    }
    company {
      _id
      slug
      name
      logo
      yearFounded
      description
      createdAt
      plan {
        _id
        name
      }
      viewerIsMember
      isDisruptor
      sponsorships {
        name
        link
        logo
      }
    }
    inViewerStack
    highlights
    socialMedia {
      twitter
      facebook
      linkedin
      youtube
      instagram
    }
    alternatives {
      _id
      name
      logo
      slug
    }
    siblings {
      _id
      name
      slug
      logo
      isDisruptor
      inViewerStack
    }
    certifications
    resources {
      ... on LinkResource {
        type
        title
        url
        addedAt
      }
      ... on DownloadResource {
        type
        title
        url
        addedAt
      }
      ... on TextResource {
        type
        title
        body
        addedAt
      }
    }
    newsworthy {
      url
      title
      description
      favicon
      siteName
    }
    integrations {
      _id
      name
      slug
    }
    solutions {
      _id
      name
      status
    }
    outsideIntegrations {
      _id
      name
      url
    }
    releasedYear
    freeTrial {
      linkHref
    }
    pricingPage
    deployment {
      ... on WebProductDeployment {
        mobileResponsive
        supportedBrowsers
      }
      ... on DesktopProductDeployment {
        platforms
      }
      ... on AppStoreProductDeployment {
        linkHref
      }
      ... on PlayStoreProductDeployment {
        linkHref
      }
    }
    assistiveTechnologiesCompatibility
    openSource {
      ... on ProductOpenSource {
        linkHref
      }
    }
    enrichedProfile
    governments {
      items {
        _id
        name
        slug
        logo
        state
        productsCount
        budget
        currency
        city {
          _id
          type
          state
          population
          governmentType
          country
          countryName
        }
        isInnovator
      }
    }
  }
`;

export default ProductFieldsFragment;
